import './search_hero';
import './featured_guides';
import './banners/major_campaign_banner';

import { trackLink } from '../Shared/utils.js';

$$('.js-product-ad').each(function(el) {
   trackLink(el, 'Homepage Featured Products', 'click', el.get('data-ga-label'));
});
